import { EmailAddress } from '@constants';
import { Button } from 'antd';
import { Link } from 'react-router-dom';
import feedbackSuccess from '@assets/bp_feedback_success.svg';

import classes from './Feedback.module.css';

const FEEDBACK_TEXT = {
  title: 'Congrats!',
  desc: 'Your application has been submitted. We’ll get back to you in 2 business days. Should you have any questions, please contact us at ',
};

export default function Feedback() {
  return (
    <div className={classes.feedback}>
      <div className={classes.content}>
        <img src={feedbackSuccess} alt="" className={classes.img} />
        <div className={classes.title}>{FEEDBACK_TEXT.title}</div>
        <div className={classes.desc}>
          {FEEDBACK_TEXT.desc}
          <a href={`mailto: ${EmailAddress.Seel}`} style={{ color: '#645AFF' }}>
            {EmailAddress.Seel}
          </a>
          .
        </div>
        <Link to="/">
          <Button>Back to home</Button>
        </Link>
      </div>
    </div>
  );
}
